import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo, applyHeadSeo } from '@/lib/seo';
import { applyJsonLd } from '@/lib/schema';

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    const entry = resolveSeo(location.pathname);
    applyHeadSeo(entry);
    applyJsonLd(location.pathname);
  }, [location.pathname]);

  return null;
}